import { render, staticRenderFns } from "./ClienteIndex.vue?vue&type=template&id=3662f4de"
import script from "./ClienteIndex.vue?vue&type=script&lang=js"
export * from "./ClienteIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports